import Backbone from "backbone";
import { MISMATCH_TYPE } from "lib/constants";
import Base from "./base";

const ROLE_TYPE_MAP = {
    1: 2 ** 3,
    2: 2 ** 4,
    3: 2 ** 5,
    4: 2 ** 6,
};

const SHIFT_TYPE_MAP = {
    DAY: 2 ** 0,
    SWING: 2 ** 1,
    NIGHT: 2 ** 2,
};

const Position = Base.Model.extend({
    defaults: {
        company_name: "",
        title: "",
        wage: "",
        schedule_start: "",
        schedule_duration: "",
        schedule_description: "",
        num_mismatch: 0,
        mismatch: [],
    },
    getAllMismatches(type) {
        return this.get("mismatch").filter((m) => m.type === type);
    },
    getMismatch(type) {
        return this.getAllMismatches(type).pop();
    },
    hasMismatch() {
        return this.get("mismatch").length > 0;
    },
    hasSoftMismatch() {
        return this.hasAvailMismatch() || this.hasCommuteMismatch() || this.hasLocationMismatch();
    },
    getMismatchText() {
        if (this.hasCommuteMismatch()) {
            return this.get("mismatch")
                .map((m) => m.text)
                .join("<br>");
        }
        return "";
    },
    getAvailMismatches() {
        return this.getAllMismatches(MISMATCH_TYPE.AVAILABILITY);
    },
    hasAvailMismatch() {
        return this.getAvailMismatches().length > 0;
    },
    getCommuteMismatch() {
        return this.getMismatch(MISMATCH_TYPE.COMMUTE);
    },
    hasCommuteMismatch() {
        return !!this.getCommuteMismatch();
    },
    hasQualificationsMismatch() {
        return !!this.getMismatch(MISMATCH_TYPE.QUALIFICATIONS);
    },
    hasLocationMismatch() {
        return !!this.getMismatch(MISMATCH_TYPE.LOCATION);
    },
    hasExperienceMismatch() {
        return !!this.getMismatch(MISMATCH_TYPE.EXPERIENCE);
    },
    initialize() {},
});

const Positions = Backbone.Collection.extend({
    model: Position,

    areAllHardFails() {
        const okApps = this.filter((position) => !position.hasQualificationsMismatch());

        return okApps.length === 0;
    },

    getSimilarPositions() {
        return this.reduce((memo, position) => {
            if (position.hasExperienceMismatch()) {
                // Don't display suggestions if we have no WH
                return memo;
            }

            return memo.concat(position.get("similar_positions") || []);
        }, []);
    },

    getShiftTypes() {
        let types = this.reduce(
            (memo, model) => model.get("shift_types").reduce((x, y) => memo | Number(y), memo),
            0,
        );

        // Select all if none
        if (types === 0) {
            types = Object.keys(SHIFT_TYPE_MAP).reduce((x, y) => x | SHIFT_TYPE_MAP[y], 0);
        }

        return types;
    },

    getRoleTypes() {
        let types = this.reduce(
            (memo, model) => memo | ROLE_TYPE_MAP[Number(model.get("role_type"))],
            0,
        );

        // Select all if none
        if (types === 0) {
            types = Object.keys(ROLE_TYPE_MAP).reduce((x, y) => x | ROLE_TYPE_MAP[y], 0);
        }

        return types;
    },
});

export default {
    Position,
    Positions,
    ROLE_TYPE_MAP,
    SHIFT_TYPE_MAP,
};
